import { api } from "@/shared/api/instance";
import type { SetFlightMarkupBody } from "@/features/markups/api/markups";
import type { ToursFiltersState } from "../types/filters";
import { mapFiltersToRequest } from "../utils/mapFiltersToRequest";

export interface Country {
  id: number;
  name: string;
}

export type TourStatus = "pending" | "processing" | "completed" | "failed";

// Один маршрут внутри фильтра. Бэкенд отдаёт и id стран, и их названия,
// поэтому заголовок карточки можно собрать даже без сгенерированного поста.
export interface TourFilterTrip {
  to: number[];
  from: number[];
  toCountries: string[];
  fromCountries: string[];
}

// Полный payload фильтра одного прогона (даты приходят компактно "YYYYMMDD" или "").
export interface TourFilter {
  date: { to: string; from: string; delta: number };
  price: { to: number; from: number };
  trips: TourFilterTrip[];
  is_direct: boolean;
  is_round_trip: boolean;
}

// Один прогон крона. Бэкенд группирует прогоны по дням и периодам.
export interface TourHistoryItem {
  id: number;
  post: string;
  status: TourStatus;
  filter: TourFilter;
  createdAt: string;
  startedAt?: string | null;
  finishedAt?: string | null;
}

// Значение одного периода в ответе /history. id === null означает, что в этот период
// прогон не выполнялся (бэкенд присылает объект-заглушку, а не null).
export interface TourPeriodValue {
  id: number | null;
  post: string | null;
  status: TourStatus | null;
  filter: TourFilter | null;
  createdAt: string;
  startedAt?: string | null;
  finishedAt?: string | null;
}

export type TourPeriodKey = "morning" | "afternoon" | "evening";

export interface TourHistoryDay {
  date: string; // "YYYY-MM-DD"
  periods: Record<TourPeriodKey, TourPeriodValue>;
}

export interface ToursHistoryResponse {
  data: TourHistoryDay[];
  total: number;
  page: number;
  pageSizeDays: number;
  totalPages: number;
}

export const getCountries = async (): Promise<Country[]> => {
  const response = await api.get<Country[]>("/api/v1/andromeda/country");
  return response.data;
};

export const getHistory = async (params: {
  page: number;
  pageSize: number;
}): Promise<ToursHistoryResponse> => {
  const res = await api.get<ToursHistoryResponse>(
    "/api/v1/andromeda/search/history",
    { params }
  );
  return res.data;
};

// Сохранение долгосрочного фильтра = запуск поиска. Крон подхватывает последний
// сохранённый поиск как повторяющийся фильтр. Отдельного /filter эндпоинта на
// бэкенде нет — переиспользуем существующий POST /search.
export const saveFilter = async (filters: ToursFiltersState): Promise<void> => {
  await api.post("/api/v1/andromeda/search", mapFiltersToRequest(filters));
};

// Используется фичей markups (SetMarkupModal) — оставляем при удалении ручного флоу.
export const setToursMarkup = async (id: number, body: SetFlightMarkupBody) => {
  const res = await api.put(`/api/v1/andromeda/offers/${id}/markup`, body);
  return res;
};
